export default [
  { to: '/emails/logs', display: 'Last sent emails' },
  { to: '/emails/variations', display: 'Templates variations' },
  { to: '/emails/conversations', display: 'User email conversations', contributorsAllowed: true },
];
